module.exports = __webpack_public_path__ + "img/edge_nature_barrage.d6c04040.svg";